<template>
    <app-wrapper>
        <app-header medium-max-width="max-w-1000" :is-hidden-menu="true">
            <template #top>
                <div class="w-full flex items-center">
                    <div class="flex-auto text-center">
                        <!-- Progress-toward-unlock copy only renders when a reward actually exists.
                             At the rate floor / paid-in-full band nothing unlocks, so promising
                             "better loan terms" or counting payments toward a target is false. -->
                        <h2 v-if="hasUnlockableRewards" class="mb-1 mt-0 md:text-4xl">You're On Your Way to Better Loan Terms!</h2>
                        <h2 v-else class="mb-1 mt-0 md:text-4xl">Cash Back Available!</h2>
                        <span v-if="!hasUnlockableRewards" class="text-gray-400">You've built up cash back on your loan — it's available to take today.</span>
                        <span v-else-if="storeData.advancedRefiFrozen && storeData.advancedRefiFrozenDaysRemaining > 0" class="text-gray-400">
                            You've paid enough for better refi options. They unlock in {{ storeData.advancedRefiFrozenDaysRemaining }} days.
                        </span>
                        <span v-else class="text-gray-400">You've completed {{ storeData.paidPayments }} of the {{ phase2TargetPayments }} payments needed to unlock additional rewards</span>
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">

            <template #main>

                <PaymentsCompletedProgressBar
                    v-if="hasUnlockableRewards"
                    :total-value="phase2TargetPayments"
                    :current-value="storeData.paidPayments"
                />

                <AppBoxContent 
                    class="my-8"
                    width="full" 
                    rounded="lg"
                    bg-class-color="bg-white" 
                    :use-min-height="false"
                    :remove-max-width="true"
                >
                    <div class="cashback-box-content-container text-[#6B7280]">

                        <InfoBox>
                            <div class="flex gap-2">
                                <div>
                                    <i class="fa fa-check-circle text-green-600 text-[20px]"></i>
                                </div>
                                <div>
                                    <div class="pb-2"><p class="text-lg italic">Cash Back Available Today</p></div>
                                    <div class="text-2xl text-black"><FontBold>{{ storeData.maxCashBack | formatMoney}}</FontBold></div>
                                </div>
                            </div>
                        </InfoBox>

                        <div class="mt-6">
                            <p>What happens if you take cash today?</p>
                            <ul class="list-disc pl-4 ml-2 mt-2">
                                <li>Receive {{ storeData.maxCashBack | formatMoney }} immediately</li>
                                <li>Monthly payment stays the same</li>
                                <li>Loan term stays the same</li>
                                <li>{{ storeData.maxCashBack | formatMoney }} is added to your loan balance</li>
                            </ul>
                        </div>

                        <Alert type="warning" class="mt-6">
                            Accepting cash back resets your progress toward future rewards.
                        </Alert>

                        <div>
                            <a class="bg-[#de9e52] no-underline text-white py-2 px-4 rounded-md inline-block mt-2" href="javascript:void(0)" @click="next()">Refinance &amp; Get Cash</a>
                        </div>
                    </div>
                </AppBoxContent>


                <div v-if="storeData.showPhase2Teaser && (storeData.previewBetterRate || storeData.previewBalanceBonus > 0)" class="rounded-lg  border border-[#2db405] bg-[#e0e8df] shadow-2xl p-8 mb-6">
                    <h2 class="text-2xl font-bold mb-2">Keep Making Payments</h2>
                    <p v-if="storeData.advancedRefiFrozen && storeData.advancedRefiFrozenDaysRemaining > 0" class="text-gray-700 mb-4">
                        You've paid enough to unlock better terms. They'll be available in <span class="text-2xl font-bold">{{ storeData.advancedRefiFrozenDaysRemaining }}</span> days.
                    </p>
                    <p v-else class="text-gray-700 mb-4">After <span class="text-2xl font-bold">{{ paymentsAway() }}</span> more on-time {{ paymentsAway() === 1 ? 'payment' : 'payments' }}, you'll unlock:</p>

                    <ul class="list-disc pl-4 my-4">
                        <li v-if="storeData.previewBalanceBonus > 0">Up to <FontBold>{{ milestoneCashBack | formatMoney }}</FontBold> available in cash back</li>
                        <li>Improved loan terms</li>
                        <li>More flexible repayment options</li>
                    </ul>

                    <div>
                        <a :href="storeData.portalUrl"  class="bg-[#2b8189] no-underline text-white py-2 px-4 rounded-md inline-block mt-2">Continue Making Payments</a>
                        <small v-if="storeData.advancedRefiFrozen && storeData.advancedRefiFrozenDaysRemaining > 0" class="block mt-1 text-[11px]">Better rewards unlock when the age-freeze window ends</small>
                        <small v-else class="block mt-1 text-[11px]">Make your next payments on time and maintain consistent income to unlock these rewards.</small>
                    </div>
                </div>

            </template>
        </app-body>
    </app-wrapper>
</template>

<script>
import AppBoxContent from './../../../../components/AppBoxContent.vue';
import PaymentsCompletedProgressBar from '../components/PaymentsCompletedProgressBar.vue';
import FontBold from '../components/FontBold.vue';
import Alert from '../components/Alert.vue';
import InfoBox from '../components/InfoBox.vue';
import { RefinanceStepMixin } from './../mixins/RefinanceStepMixin';
import { RefinanceFiltersMixin } from './../mixins/RefinanceFiltersMixin';

export default {
    name: 'RefinanceElegible',
    mixins: [RefinanceStepMixin, RefinanceFiltersMixin],
    components: {
        PaymentsCompletedProgressBar,
        AppBoxContent,
        FontBold,
        Alert,
        InfoBox,
    },
}
</script>
